module.exports = __webpack_public_path__ + "static/media/loading.2589c4a7.gif";